import React from 'react';
import { Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import styles from './InputHint.module.css';

interface IInputHint {
  hint: string;
  loading?: boolean;
  onClose: () => void;
}

const InputHint = ({ hint, loading = false, onClose }: IInputHint) => (
  <>
    <div className={styles.inputHint}>
      {loading ? <div>Loading...</div> : <div>{hint}</div>}
      <Button color="primary" size="small" className={styles.closeHint} endIcon={<Close />} onClick={onClose} />
    </div>
  </>
);

export default InputHint;
